import { firstValueFrom } from 'rxjs';

import { StaticContentService } from '../static-content-service/static-content-service';

export const staticContentFactory = (staticContentService: StaticContentService) => {
  return () => firstValueFrom(staticContentService.loadStaticContent());
};
